// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gc-user-img {
  width: 46px;
  height: 46px;
  font-size: 18px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 46px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gc-user-name {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #1F2937;
}

p.gc-user-handle {
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: rgba(75, 85, 99, 0.5);
}

.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.opacity-6 {
  cursor: default;
  opacity: 0.6;
}

.relative {
  position: relative;
}

:host ::ng-deep .p-menu.p-menu-overlay {
  position: absolute !important;
  top: 13px !important;
  left: -193px !important;
}

.gc-user-agencies {
  width: 31px;
  height: 31px;
  overflow: hidden;
  color: #2d388b;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  flex: 0 0 31px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gc-user-agencies .last-agency-icon {
  border-radius: 50%;
  background-color: #E7ECF0;
  color: #2d388b;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  width: 31px;
  height: 31px;
}

.add-associated-agency {
  width: 100px;
  height: 30px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  /* identical to box height, or 188% */
  color: #1F2937;
  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
}

.add-associated-agency-plus {
  cursor: pointer;
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  border: 1px solid #2B3990;
  border-radius: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.country-code, .country-code-dropdown {
  width: 32px;
  height: 30px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 30px;
  color: #4B5563;
  mix-blend-mode: normal;
}

.country-code-dropdown {
  width: 50px;
}

.password-text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1F2937;
}

.assing-agncy {
  height: 54px;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
}
.assing-agncy .assing-agncy-img {
  width: 32px;
  height: 32px;
  font-size: 18px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff url('agency-icon-blue.8eed463b0cbddad9.svg') no-repeat center center;
  background-size: 45%;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #C7C7C7;
  padding: 4px;
}

.remove-chips {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: right;
  color: #F65353;
  cursor: pointer;
}

.password-error-text {
  font-size: 12px;
  padding-left: 10px;
}

.gc-pr-12 {
  padding-right: 12px !important;
}

.gc-pl-12 {
  padding-left: 12px !important;
}

.gc-add-agency {
  padding-bottom: 20px;
  margin-bottom: 13px;
  border-width: 0 0 1px 0;
  border-style: dashed;
  border-color: #D1D5DB;
}
.gc-add-agency:first-child, .gc-add-agency:last-child {
  border: none !important;
}

.disable-click {
  pointer-events: none;
}

.cursor-pointer {
  cursor: pointer;
}

.table-header h2 {
  line-height: 1;
}
.table-header .table-search-wrapper {
  max-width: 360px;
  flex: 1 1 auto;
  margin: 0;
}
.table-header p-button {
  margin: 0;
}
@media (max-width: 1200px) {
  .table-header {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .table-header .table-search-wrapper {
    max-width: 100%;
    width: 100%;
  }
}

.m-l-12 {
  margin-left: 12px;
}

:host ::ng-deep .p-checkbox-label {
  margin-left: 0.5rem;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
